export const MAX_SEARCH_RESULTS_COUNT = 10;
export const MIN_QUERY_LENGTH = 1;
